import { useTreeStateContext } from "../../../contexts/TreeContext";
import { useTreeDispatchContext } from "../../../contexts/TreeContext";
import useShiftKey from "../../../hook/useShiftKey";

// Component for active the multiple blocks selections, this components replace the use of the alt key press to active the selection
function ButtonSelection() {

    const { changeShiftKey, shiftKey } = useShiftKey()
    const onClick = () => changeShiftKey();

    // Highled the component if alt key is pressed or not
    return <div className={shiftKey ? "selection highlighted" : "selection"} onClick={onClick}></div>
}

export default ButtonSelection